<div class="section user-detail-block">
    <span>{{ fullName }}</span>
    <span>{{ roleName }}</span>
</div>

<div class="section">
    <ddv-user-preference-labeled-row
        id="auto-dismiss-error-row"
        [label]="'Auto Dismiss Alerts'"
        [message]="'Automatically hides alerts after display'"
    >
        <cc-option-toggle
            id="auto-dismiss-error"
            [(value)]="autoDismissErrors"
            [labels]="['Yes', 'No']"
            (valueChange)="updateAutoDismissErrorsPreference()"
        >
        </cc-option-toggle>
    </ddv-user-preference-labeled-row>
</div>

@if (hasBothFundAvailability) {
    <div class="section">
        <ddv-user-preference-labeled-row id="fund-names-source-row" [label]="'Fund Names Source'">
            <cc-option-toggle
                id="fund-names-source"
                [(value)]="preferHIForFundNames"
                [labels]="['Investors', 'HSMain']"
                (valueChange)="updateFundNamesSourcePreference()"
            >
            </cc-option-toggle>
        </ddv-user-preference-labeled-row>
    </div>
}

<ddv-user-preferences-default-query-params
    [fuzzyDates]="fuzzyDates"
    [(fromDate)]="startDate"
    [(toDate)]="endDate"
    [isMultiClient]="isMultiClient"
    [clients]="clients"
    [(clientCodes)]="clientCodes"
    [funds]="funds"
    [(fundCodes)]="fundCodes"
    (fromDateChange)="updateStartDatePreference()"
    (toDateChange)="updateEndDatePreference()"
    (clientCodesChange)="updateClientCodesPreference()"
    (fundCodesChange)="updateFundCodesPreference()"
>
</ddv-user-preferences-default-query-params>

@if (showNQSAndCFBLinks) {
    <ddv-user-preferences-external-links [clientCode]="clientCode"></ddv-user-preferences-external-links>
}
